export default __webpack_public_path__ + "static/media/beton_3.808fea26.webp";